export const PRODUCT_CATEGORIES = [
  { value: 'injectable', label: 'Injectable' },
  { value: 'supplement', label: 'Supplement' },
  { value: 'topical', label: 'Topical' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'supply', label: 'Supply' },
  { value: 'peptide', label: 'Peptide' },
  { value: 'other', label: 'Other' },
] as const;

export const PRODUCT_CATEGORY_LABELS: Record<string, string> = Object.fromEntries(
  PRODUCT_CATEGORIES.map(c => [c.value, c.label])
);

export const PRODUCT_CATEGORY_VALUES = PRODUCT_CATEGORIES.map(c => c.value);

export const PRODUCT_UNITS = [
  { value: 'unit', label: 'Unit' },
  { value: 'each', label: 'Each' },
  { value: 'dose', label: 'Dose' },
  { value: 'vial', label: 'Vial' },
  { value: 'ml', label: 'mL' },
  { value: 'mg', label: 'mg' },
  { value: 'oz', label: 'oz' },
  { value: 'pack', label: 'Pack' },
] as const;

export const PRODUCT_UNIT_LABELS: Record<string, string> = Object.fromEntries(
  PRODUCT_UNITS.map(u => [u.value, u.label])
);

export const PRODUCT_UNIT_VALUES = PRODUCT_UNITS.map(u => u.value);

export const LOT_STATUSES = [
  { value: 'available', label: 'Available', color: 'green' },
  { value: 'depleted', label: 'Depleted', color: 'gray' },
  { value: 'expired', label: 'Expired', color: 'red' },
  { value: 'recalled', label: 'Recalled', color: 'orange' },
] as const;

export const LOT_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  LOT_STATUSES.map(s => [s.value, s.label])
);

export const LOT_STATUS_COLORS: Record<string, string> = Object.fromEntries(
  LOT_STATUSES.map(s => [s.value, s.color])
);

export const USAGE_ACTIONS = [
  { value: 'used', label: 'Used' },
  { value: 'wasted', label: 'Wasted' },
  { value: 'returned', label: 'Returned' },
  { value: 'adjusted', label: 'Adjusted' },
] as const;

export const USAGE_ACTION_LABELS: Record<string, string> = Object.fromEntries(
  USAGE_ACTIONS.map(a => [a.value, a.label])
);
